import { render, staticRenderFns } from "./GroupListItem.vue?vue&type=template&id=03bc8784&"
import script from "./GroupListItem.vue?vue&type=script&lang=js&"
export * from "./GroupListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports